import { render, staticRenderFns } from "./politica_de_confidentialitate.vue?vue&type=template&id=0d8fa806"
import script from "./politica_de_confidentialitate.vue?vue&type=script&lang=js"
export * from "./politica_de_confidentialitate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports